(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koya-bundle-offers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBundleSection = (scope = document) => {
      scope.querySelectorAll('[data-bundle-offers]').forEach((section) => {
        if (section.dataset.bundleReady === 'true') return;
        section.dataset.bundleReady = 'true';

        const track = section.querySelector('[data-bundle-track]');
        const prevBtn = section.querySelector('[data-bundle-nav-prev]');
        const nextBtn = section.querySelector('[data-bundle-nav-next]');
        const navWrap = section.querySelector('[data-bundle-nav]');
        const dotsWrap = section.querySelector('[data-bundle-dots]');
        const dots = Array.from(section.querySelectorAll('[data-bundle-dot]'));
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        // Variant Selection click handler
        section.querySelectorAll('[data-bundle-variant-btn]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const card = btn.closest('.bundle-offers-card');
            if (!card) return;

            // Toggle active state in this card's variant list
            card.querySelectorAll('[data-bundle-variant-btn]').forEach((otherBtn) => {
              otherBtn.classList.remove('is-active');
              otherBtn.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');

            // Update Price
            const priceEl = card.querySelector('[data-card-price]');
            if (priceEl && btn.dataset.variantPrice) {
              priceEl.textContent = btn.dataset.variantPrice;
            }

            // Update Compare Price
            const compareEl = card.querySelector('[data-card-compare]');
            if (compareEl) {
              if (btn.dataset.variantCompare) {
                compareEl.textContent = btn.dataset.variantCompare;
                compareEl.style.display = '';
              } else {
                compareEl.textContent = '';
                compareEl.style.display = 'none';
              }
            }

            // Update Savings Tag
            const savingsEl = card.querySelector('[data-card-savings]');
            if (savingsEl) {
              if (btn.dataset.variantSavings) {
                savingsEl.textContent = btn.dataset.variantSavings;
                savingsEl.style.display = '';
              } else {
                savingsEl.textContent = '';
                savingsEl.style.display = 'none';
              }
            }

            // Update Discount Pill
            const discountPill = card.querySelector('[data-card-discount-pill]');
            const savePercent = Number(btn.dataset.variantSavePercent || 0);
            if (discountPill) {
              if (savePercent > 0) {
                discountPill.innerHTML = `
                  <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true">
                    <path d="M12 2C8 6 6 8.5 6 12a6 6 0 0 0 12 0c0-3.5-2-6-6-10zm0 15a3 3 0 0 1-3-3c0-1.8 1.2-3.3 2.5-4.8.4.8.9 1.5 1.5 2.1.8.8 1 1.7 1 2.7a3 3 0 0 1-2 3z"/>
                  </svg>
                  <span>Combo Offer • Save ${savePercent}%</span>
                `;
                discountPill.classList.remove('bundle-offers-card__discount-pill--combo');
                discountPill.style.display = '';
              } else {
                discountPill.innerHTML = `
                  <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true">
                    <path d="M12 2C8 6 6 8.5 6 12a6 6 0 0 0 12 0c0-3.5-2-6-6-10zm0 15a3 3 0 0 1-3-3c0-1.8 1.2-3.3 2.5-4.8.4.8.9 1.5 1.5 2.1.8.8 1 1.7 1 2.7a3 3 0 0 1-2 3z"/>
                  </svg>
                  <span>Combo Offer</span>
                `;
                discountPill.classList.add('bundle-offers-card__discount-pill--combo');
                discountPill.style.display = '';
              }
            }

            // Update Quick Add button
            const quickAddBtn = card.querySelector('[data-bundle-quick-add]');
            if (quickAddBtn) {
              quickAddBtn.dataset.variantId = btn.dataset.variantId;
              const isAvailable = btn.dataset.variantAvailable !== 'false';
              quickAddBtn.disabled = !isAvailable;
              const labelEl = quickAddBtn.querySelector('.bundle-offers-card__btn-label');
              if (labelEl) {
                labelEl.textContent = isAvailable ? (quickAddBtn.dataset.defaultLabel || 'Add bundle') : 'Sold out';
              }
            }
          });
        });

        // Carousel Scroll, Dots & Navigation Handling
        if (track) {
          const cards = Array.from(track.querySelectorAll('.bundle-offers-card'));

          const updateScrollState = () => {
            const maxScroll = track.scrollWidth - track.clientWidth;
            const isScrollable = maxScroll > 8;

            // Dynamically show or hide dots based on whether products actually overflow
            if (dotsWrap) {
              dotsWrap.style.display = isScrollable ? 'flex' : 'none';
              if (!isScrollable) {
                dotsWrap.setAttribute('aria-hidden', 'true');
              } else {
                dotsWrap.removeAttribute('aria-hidden');
              }
            }

            // Dynamically show or hide nav buttons if content doesn't scroll
            if (navWrap) {
              navWrap.style.display = isScrollable ? 'flex' : 'none';
            }

            if (prevBtn instanceof HTMLButtonElement) {
              prevBtn.disabled = track.scrollLeft <= 4;
            }

            if (nextBtn instanceof HTMLButtonElement) {
              nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
            }

            // Sync active pagination dot
            if (dots.length && cards.length && isScrollable) {
              const scrollLeft = track.scrollLeft;

              if (scrollLeft >= maxScroll - 4) {
                // Scrolled all the way to end: activate last dot
                dots.forEach((dot, index) => {
                  const isLast = index === dots.length - 1;
                  dot.classList.toggle('is-active', isLast);
                  dot.setAttribute('aria-selected', isLast ? 'true' : 'false');
                });
              } else {
                const trackRect = track.getBoundingClientRect();
                let bestIndex = 0;
                let minDistance = Infinity;

                cards.forEach((card, index) => {
                  const cardRect = card.getBoundingClientRect();
                  const distance = Math.abs(cardRect.left - trackRect.left);
                  if (distance < minDistance) {
                    minDistance = distance;
                    bestIndex = index;
                  }
                });

                dots.forEach((dot, index) => {
                  const isActive = index === bestIndex;
                  dot.classList.toggle('is-active', isActive);
                  dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });
              }
            }
          };

          const scrollTrack = (direction) => {
            const card = track.querySelector('.bundle-offers-card');
            const step = card ? card.getBoundingClientRect().width + 18 : Math.max(280, track.clientWidth * 0.75);
            track.scrollBy({
              left: direction === 'prev' ? -step : step,
              behavior: 'smooth',
            });
          };

          if (prevBtn instanceof HTMLButtonElement) {
            prevBtn.addEventListener('click', () => scrollTrack('prev'));
          }

          if (nextBtn instanceof HTMLButtonElement) {
            nextBtn.addEventListener('click', () => scrollTrack('next'));
          }

          // Dot click navigation
          dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              const targetIdx = Number(dot.dataset.bundleDot);
              const targetCard = cards[targetIdx];
              if (targetCard) {
                const cardRect = targetCard.getBoundingClientRect();
                const trackRect = track.getBoundingClientRect();
                const scrollOffset = cardRect.left - trackRect.left + track.scrollLeft;
                track.scrollTo({
                  left: scrollOffset,
                  behavior: 'smooth',
                });
              }
            });
          });

          track.addEventListener('scroll', () => window.requestAnimationFrame(updateScrollState), { passive: true });
          window.addEventListener('resize', () => window.requestAnimationFrame(updateScrollState), { passive: true });
          window.requestAnimationFrame(updateScrollState);
        }

        // Quick Add to Cart Handler
        section.querySelectorAll('[data-bundle-quick-add]').forEach((btn) => {
          btn.addEventListener('click', async (event) => {
            event.preventDefault();
            const variantId = btn.dataset.variantId;
            if (!variantId || btn.disabled) return;

            btn.disabled = true;
            btn.classList.add('is-loading');

            const cartDrawer = document.querySelector('cart-drawer-component');
            const cartDrawerContent = cartDrawer?.querySelector('.cart-drawer__content');
            const cartDrawerLiveRegion = cartDrawer?.querySelector('[ref="liveRegion"]');

            const setDrawerBusy = (isBusy) => {
              if (cartDrawerContent instanceof HTMLElement) {
                if (isBusy) {
                  cartDrawerContent.dataset.loading = 'true';
                  cartDrawerContent.setAttribute('aria-busy', 'true');
                } else {
                  delete cartDrawerContent.dataset.loading;
                  cartDrawerContent.removeAttribute('aria-busy');
                }
              }
              if (cartDrawerLiveRegion instanceof HTMLElement) {
                cartDrawerLiveRegion.textContent = isBusy ? 'Adding bundle to bag...' : '';
              }
            };

            setDrawerBusy(true);

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) {
                throw new Error(cart?.description || cart?.message || 'Failed to add bundle to cart');
              }

              // Success: Show checkmark feedback
              btn.classList.remove('is-loading');
              btn.classList.add('is-success');

              // Open cart drawer
              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();

              // Dispatch Shopify standard cart update event
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'koya-bundle-offers',
                      itemCount: cart.item_count,
                      variantId: String(variantId),
                    },
                  },
                })
              );

              setTimeout(() => {
                btn.classList.remove('is-success');
                btn.disabled = false;
              }, 2200);
            } catch (error) {
              console.error('Bundle Add To Cart error:', error);
              btn.classList.remove('is-loading');
              btn.disabled = false;
            } finally {
              window.requestAnimationFrame(() => setDrawerBusy(false));
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBundleSection());
    } else {
      initBundleSection();
    }

    document.addEventListener('shopify:section:load', (event) => initBundleSection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-custom-gift-combo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, locale, currency) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return (currency === 'INR' ? '₹' : '$') + ((Number(cents) || 0) / 100).toFixed(2);
      }
    };

    const showToast = (section, message) => {
      let toast = section.querySelector('[data-gift-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'wew-gift-combo__toast';
        toast.dataset.giftToast = 'true';
        section.appendChild(toast);
      }

      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2400);
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartTrigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('.wew-header__right a[href*="/cart"]') ||
        document.querySelector('.wew-mobile-tabs a[href*="/cart"]');

      if (!cartTrigger) return;

      const countNode =
        cartTrigger.querySelector('.wew-header__cart-count') ||
        cartTrigger.querySelector('.wew-mobile-tabs__badge');

      if (countNode) countNode.textContent = String(count);
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      const cartLink = document.querySelector('.wew-mobile-tabs a[href*="/cart"]');
      if (cartLink) {
        window.location.href = cartLink.href;
      }
    };

    const setupLoopCarousel = (carousel) => {
      if (!(carousel instanceof HTMLElement) || carousel.dataset.loopReady === 'true') return;
      const originals = Array.from(carousel.children).filter(
        (child) => child instanceof HTMLElement && child.hasAttribute('data-gift-card')
      );

      if (originals.length < 3) return;

      carousel.dataset.loopReady = 'true';

      const cloneCards = (cards) =>
        cards.map((card) => {
          const clone = card.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.removeAttribute('data-gift-card');
            clone.dataset.giftCardClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('role', 'presentation');
          }
          return clone;
        });

      const prepend = document.createDocumentFragment();
      const append = document.createDocumentFragment();

      cloneCards(originals).reverse().forEach((clone) => prepend.appendChild(clone));
      cloneCards(originals).forEach((clone) => append.appendChild(clone));

      carousel.prepend(prepend);
      carousel.append(append);

      const measureLoopWidth = () => {
        const cardWidth = originals[0].getBoundingClientRect().width;
        const styles = getComputedStyle(carousel);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return (cardWidth + gap) * originals.length;
      };

      const resetToMiddle = () => {
        const width = measureLoopWidth();
        carousel.scrollLeft = width;
      };

      requestAnimationFrame(resetToMiddle);

      let rafId = 0;
      const normalizeScroll = () => {
        window.cancelAnimationFrame(rafId);
        rafId = window.requestAnimationFrame(() => {
          const width = measureLoopWidth();
          const total = carousel.scrollWidth;
          const leftEdge = width * 0.45;
          const rightEdge = total - carousel.clientWidth - width * 0.45;

          if (carousel.scrollLeft <= leftEdge) {
            carousel.scrollLeft += width;
          } else if (carousel.scrollLeft >= rightEdge) {
            carousel.scrollLeft -= width;
          }
        });
      };

      carousel.addEventListener('scroll', normalizeScroll, { passive: true });
      window.addEventListener('resize', resetToMiddle, { passive: true });
    };

    const initGiftCombo = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-gift-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-gift-panel]'));
      const cards = Array.from(section.querySelectorAll('.wew-gift-combo__carousel > [data-gift-card]'));
      const selectedIds = [];

      const locale = section.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
      const currency = section.dataset.currency || 'INR';
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const discountThreshold = Number(section.dataset.discountThreshold || 99900);
      const discountPercent = Number(section.dataset.discountPercent || 5);

      const summaryList = section.querySelector('[data-gift-summary-list]');
      const subtotalNode = section.querySelector('[data-gift-subtotal]');
      const savingsNode = section.querySelector('[data-gift-savings]');
      const totalNode = section.querySelector('[data-gift-total]');
      const discountRow = section.querySelector('[data-gift-discount-row]');
      const progressFill = section.querySelector('[data-gift-progress]');
      const progressCopy = section.querySelector('[data-gift-progress-copy]');
      const countNode = section.querySelector('[data-gift-count]');
      const addButton = section.querySelector('[data-gift-add]');
      const addLabel = section.querySelector('[data-gift-add-label]');
      const resetButton = section.querySelector('[data-gift-reset]');

      const cardsById = new Map(cards.map((card) => [card.dataset.giftId, card]));
      const carousel = section.querySelector('[data-gift-carousel]');
      if (carousel) {
        setupLoopCarousel(carousel);
      }

      const selectedCards = () => selectedIds.map((id) => cardsById.get(id)).filter(Boolean);

      const updateCardState = () => {
        cards.forEach((card) => {
          const isSelected = selectedIds.includes(card.dataset.giftId);
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const renderSummary = () => {
        const items = selectedCards();
        const subtotal = items.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const thresholdReached = subtotal >= discountThreshold;
        const savings = thresholdReached ? Math.round((subtotal * discountPercent) / 100) : 0;
        const total = subtotal - savings;
        const progress = discountThreshold > 0 ? Math.min((subtotal / discountThreshold) * 100, 100) : 0;

        if (countNode) countNode.textContent = `${items.length} selected`;
        if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, locale, currency);
        if (savingsNode) savingsNode.textContent = formatMoney(savings, locale, currency);
        if (totalNode) totalNode.textContent = formatMoney(total, locale, currency);
        if (progressFill) progressFill.style.width = `${progress}%`;
        if (discountRow) discountRow.hidden = !thresholdReached || savings <= 0;

        if (progressCopy) {
          if (!items.length) {
            progressCopy.textContent = 'Start selecting products';
          } else if (thresholdReached) {
            progressCopy.textContent = `${discountPercent}% savings unlocked`;
          } else {
            const remaining = Math.max(discountThreshold - subtotal, 0);
            progressCopy.textContent = `${formatMoney(remaining, locale, currency)} left to unlock ${discountPercent}% off`;
          }
        }

        if (summaryList) {
          if (!items.length) {
            summaryList.innerHTML =
              '<p class="wew-gift-combo__empty">Choose products from one or more occasion tabs. The combo stays in sync as you add or remove items.</p>';
          } else {
              summaryList.innerHTML = items
              .map((card) => {
                const title = card.dataset.title || 'Product';
                const price = card.dataset.price || 0;
                return `
                  <p class="wew-gift-combo__summary-item" data-selected-item="${card.dataset.giftId}">
                    <span>
                      ${escapeHtml(title)}
                      <small>${escapeHtml(card.dataset.collection || '')}</small>
                    </span>
                    <strong>
                      ${formatMoney(price, locale, currency)}
                      <button type="button" data-remove-gift-id="${card.dataset.giftId}" aria-label="Remove ${escapeHtml(title)}">Remove</button>
                    </strong>
                  </p>
                `;
              })
              .join('');
          }
        }

        if (addButton) {
          addButton.disabled = items.length === 0;
        }
        if (addLabel) {
          if (!items.length) {
            addLabel.textContent = 'Pick items to continue';
          } else {
          addLabel.textContent = thresholdReached ? 'Add combo with savings' : 'Add room combo';
          }
        }

        updateCardState();
      };

      const activatePanel = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.target === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      const addCard = (card) => {
        if (card.dataset.available === 'false') {
          showToast(section, 'This product is sold out.');
          return;
        }

        if (selectedIds.includes(card.dataset.giftId)) return;

        selectedIds.push(card.dataset.giftId);
        renderSummary();
      };

      const removeCard = (giftId) => {
        const index = selectedIds.indexOf(giftId);
        if (index === -1) return;
        selectedIds.splice(index, 1);
        renderSummary();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activatePanel(tab.dataset.target));
      });

      section.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-gift-id]');
        if (removeButton) {
          event.preventDefault();
          removeCard(removeButton.dataset.removeGiftId);
          return;
        }

        const toggleButton = event.target.closest('[data-gift-card-toggle]');
        if (toggleButton) {
          const card = toggleButton.closest('[data-gift-card]');
          if (!card) return;
          event.preventDefault();
          if (selectedIds.includes(card.dataset.giftId)) {
            removeCard(card.dataset.giftId);
          } else {
            addCard(card);
          }
          return;
        }

        const card = event.target.closest('[data-gift-card]');
        if (!card) return;

        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-gift-card]');
        if (!card) return;
        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      addButton?.addEventListener('click', async () => {
        const items = selectedCards().map((card) => ({
          id: Number(card.dataset.variantId),
          quantity: 1,
        }));

        addButton.disabled = true;
        addButton.dataset.loading = 'true';

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const cart = await response.json();
          if (!response.ok || cart?.status) {
            throw new Error(cart?.description || cart?.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'wew-gift-combo',
                  itemCount: cart.item_count,
                },
              },
            })
          );

          syncHeaderCartCount(cart.item_count);
          showToast(section, 'Your room combo was added to cart.');
          openCartDrawer();
        } catch (error) {
          console.error(error);
          showToast(section, 'We could not add the combo. Please try again.');
        } finally {
          addButton.disabled = selectedIds.length === 0;
          addButton.dataset.loading = 'false';
          renderSummary();
        }
      });

      resetButton?.addEventListener('click', () => {
        selectedIds.length = 0;
        renderSummary();
      });

      const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (initialTab?.dataset.target) {
        activatePanel(initialTab.dataset.target);
      }

      renderSummary();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-wew-gift-combo]').forEach(initGiftCombo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-premium-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('.wew-header');

    const updateHeaderMetrics = () => {
      if (!header) return;
      const h = header.offsetHeight || 70;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
      document.body.style.setProperty('--header-height', `${h}px`);
      const spacer = document.querySelector('.wew-header-spacer');
      if (spacer) {
        spacer.style.height = `${h}px`;
      }
    };

    const applyHeaderScrollState = () => {
      if (!header) return;
      const currentScrollY = window.scrollY;
      header.dataset.scrolled = currentScrollY > 8 ? 'true' : 'false';
    };

    const updateCartCount = (itemCount) => {
      const countNodes = document.querySelectorAll('.wew-header__cart-count');
      if (!countNodes.length) return;

      countNodes.forEach((countNode) => {
        if (!(countNode instanceof HTMLElement)) return;

        if (itemCount > 0) {
          countNode.textContent = String(itemCount);
          countNode.hidden = false;
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.hidden = true;
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const readSessionCount = () => {
      try {
        const raw = sessionStorage.getItem('cart-count');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const value = Number(parsed?.value);
        return Number.isFinite(value) ? value : null;
      } catch (error) {
        return null;
      }
    };

    const syncFromServer = async () => {
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;
        const cart = await response.json();
        updateCartCount(Number(cart?.item_count) || 0);
      } catch (error) {
        // Ignore network failures; the session/event-based sync will still work.
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    window.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    const initialCount = readSessionCount();
    if (initialCount !== null) {
      updateCartCount(initialCount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFromServer, { once: true });
    } else {
      syncFromServer();
    }

    const openMobileMenu = () => {
      const drawer = document.querySelector('header-drawer.header-drawer');
      const details = drawer?.querySelector('details.menu-drawer-container');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      if (details) {
        details.open = true;
        details.setAttribute('open', '');
        details.classList.add('menu-open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      window.location.href = document.querySelector('.wew-mobile-tabs a[href*="/cart"]')?.href || '/cart';
    };

    document.querySelectorAll('[data-open-mobile-menu]').forEach((button) => {
      button.addEventListener('click', openMobileMenu);
    });

    document.querySelectorAll('[data-open-cart-drawer]').forEach((button) => {
      button.addEventListener('click', openCartDrawer);
    });

    document.querySelectorAll('[data-cart-drawer-recommendations]').forEach((drawer) => {
      const track = drawer.querySelector('.cart-drawer__recommendations-track');
      const prev = drawer.querySelector('[data-cart-drawer-recommendations-prev]');
      const next = drawer.querySelector('[data-cart-drawer-recommendations-next]');
      const slides = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-slide]'));
      const dots = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-dot]'));

      if (!track || slides.length === 0) return;

      const getStep = () => {
        const slide = slides[0];
        const slideWidth = slide.getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
        return slideWidth + gap;
      };

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const setArrowState = () => {
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };

      const getActiveIndex = () => {
        const viewportCenter = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - viewportCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const updateActiveState = () => {
        setActiveDot(getActiveIndex());
        setArrowState();
      };

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.cartDrawerRecommendationDot || 0);
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateActiveState);
      }, { passive: true });

      window.addEventListener('resize', updateActiveState, { passive: true });
      updateActiveState();
    });

    if (header) {
      updateHeaderMetrics();
      applyHeaderScrollState();
      window.addEventListener('scroll', applyHeaderScrollState, { passive: true });
      window.addEventListener('resize', () => {
        updateHeaderMetrics();
        applyHeaderScrollState();
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-premium-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class KoyaHeroSlider {
    constructor(element) {
      if (!element || element.dataset.initialized === 'true') return;

      this.element = element;
      this.track = element.querySelector('[data-track]');
      this.slides = Array.from(element.querySelectorAll('[data-slide]'));
      this.dots = Array.from(element.querySelectorAll('[data-dot]'));
      this.prevButton = element.querySelector('[data-action="prev"]');
      this.nextButton = element.querySelector('[data-action="next"]');
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.index = this.index >= 0 ? this.index : 0;
      this.interval = Number(element.dataset.autoplay) || 5000;
      this.timer = null;
      this.pointerId = null;
      this.dragStartX = 0;
      this.dragDeltaX = 0;
      this.isDragging = false;

      if (this.slides.length <= 1 || !this.track) {
        element.dataset.initialized = 'true';
        return;
      }

      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));

      this.dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => this.goTo(dotIndex));
      });

      this.element.addEventListener('mouseenter', () => this.stop());
      this.element.addEventListener('mouseleave', () => this.play());
      this.element.addEventListener('focusin', () => this.stop());
      this.element.addEventListener('focusout', () => this.play());
      this.element.addEventListener('pointerdown', this.onPointerDown);
      this.element.addEventListener('pointermove', this.onPointerMove);
      this.element.addEventListener('pointerup', this.onPointerUp);
      this.element.addEventListener('pointercancel', this.onPointerUp);
      this.element.addEventListener('pointerleave', this.onPointerUp);
      window.addEventListener('resize', () => this.updatePosition());

      this.goTo(this.index, true);
      this.play();
      element.dataset.initialized = 'true';
    }

    goTo(nextIndex, silent = false) {
      if (!this.slides.length) return;

      const total = this.slides.length;
      this.index = (nextIndex + total) % total;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });

      this.updatePosition();

      if (!silent) {
        this.restart();
      }
    }

    updatePosition() {
      const activeSlide = this.slides[this.index];
      if (!activeSlide || !this.track) return;

      const computedStyle = window.getComputedStyle(this.track);
      const targetInset = parseFloat(computedStyle.paddingLeft) || 0;
      const targetOffset = targetInset - activeSlide.offsetLeft;
      this.track.style.transform = `translate3d(${targetOffset}px, 0, 0)`;
    }

    onPointerDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.pointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragDeltaX = 0;
      this.isDragging = true;
      this.stop();
      this.track.style.transition = 'none';
    };

    onPointerMove = (event) => {
      if (!this.isDragging || event.pointerId !== this.pointerId) return;

      this.dragDeltaX = event.clientX - this.dragStartX;

      const activeSlide = this.slides[this.index];
      if (!activeSlide || !this.track) return;

      const computedStyle = window.getComputedStyle(this.track);
      const targetInset = parseFloat(computedStyle.paddingLeft) || 0;
      const baseOffset = targetInset - activeSlide.offsetLeft;
      this.track.style.transform = `translate3d(${baseOffset + this.dragDeltaX}px, 0, 0)`;
    };

    onPointerUp = (event) => {
      if (!this.isDragging || event.pointerId !== this.pointerId) return;

      this.isDragging = false;
      this.pointerId = null;
      this.track.style.transition = '';

      if (Math.abs(this.dragDeltaX) > 40) {
        if (this.dragDeltaX < 0) {
          this.goTo(this.index + 1);
        } else {
          this.goTo(this.index - 1);
        }
        return;
      }

      this.updatePosition();
      this.play();
    };

    play() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = window.setInterval(() => this.goTo(this.index + 1, true), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.play();
    }
  }

  const initKoyaHeroSlider = (scope = document) => {
    scope.querySelectorAll('[data-koya-hero-slider]').forEach((element) => {
      new KoyaHeroSlider(element);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initKoyaHeroSlider());
  document.addEventListener('shopify:section:load', (event) => initKoyaHeroSlider(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiSpotlight = (scope = document) => {
      scope.querySelectorAll('[data-wew-spotlight]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-spotlight-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-spotlight-panel]'));
        const seeAll = section.querySelector('[data-spotlight-see-all]');
        const carouselPrev = section.querySelector('[data-spotlight-carousel-prev]');
        const carouselNext = section.querySelector('[data-spotlight-carousel-next]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const getActivePanel = () => panels.find((panel) => panel.classList.contains('is-active')) || panels[0];
        const getActiveCarousel = () => getActivePanel()?.querySelector('.wew-spotlight__carousel') || null;

        const updateCarouselArrowState = () => {
          const carousel = getActiveCarousel();
          const maxScrollLeft = carousel ? carousel.scrollWidth - carousel.clientWidth : 0;
          const isScrollable = Boolean(carousel) && maxScrollLeft > 4;

          if (carouselPrev instanceof HTMLButtonElement) {
            carouselPrev.hidden = !isScrollable;
            carouselPrev.disabled = !carousel || carousel.scrollLeft <= 4;
          }

          if (carouselNext instanceof HTMLButtonElement) {
            carouselNext.hidden = !isScrollable;
            carouselNext.disabled = !carousel || carousel.scrollLeft >= maxScrollLeft - 4;
          }
        };

        const scrollActiveCarousel = (direction) => {
          const carousel = getActiveCarousel();
          if (!carousel) return;

          const card = carousel.querySelector('.wew-spotlight-card');
          const step = card ? card.getBoundingClientRect().width + 26 : Math.max(240, carousel.clientWidth * 0.8);
          carousel.scrollBy({
            left: direction === 'prev' ? -step : step,
            behavior: 'smooth',
          });
        };

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.spotlightTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;

            if (isActive && seeAll && panel.dataset.spotlightUrl) {
              seeAll.href = panel.dataset.spotlightUrl;
            }
          });

          window.requestAnimationFrame(updateCarouselArrowState);
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => activate(tab.dataset.spotlightTarget));
        });

        if (carouselPrev instanceof HTMLButtonElement) {
          carouselPrev.addEventListener('click', () => scrollActiveCarousel('prev'));
        }

        if (carouselNext instanceof HTMLButtonElement) {
          carouselNext.addEventListener('click', () => scrollActiveCarousel('next'));
        }

        panels.forEach((panel) => {
          const carousel = panel.querySelector('.wew-spotlight__carousel');
          if (carousel) {
            carousel.addEventListener(
              'scroll',
              () => window.requestAnimationFrame(updateCarouselArrowState),
              { passive: true }
            );
          }
        });

        section.querySelectorAll('[data-wew-spotlight-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;

            const cartDrawer = document.querySelector('cart-drawer-component');
            const cartDrawerContent = cartDrawer?.querySelector('.cart-drawer__content');
            const cartDrawerLiveRegion = cartDrawer?.querySelector('[ref="liveRegion"]');

            const setDrawerLoading = (loading) => {
              if (cartDrawerContent instanceof HTMLElement) {
                if (loading) {
                  cartDrawerContent.dataset.loading = 'true';
                  cartDrawerContent.setAttribute('aria-busy', 'true');
                } else {
                  delete cartDrawerContent.dataset.loading;
                  cartDrawerContent.removeAttribute('aria-busy');
                }
              }

              if (cartDrawerLiveRegion instanceof HTMLElement && loading) {
                cartDrawerLiveRegion.textContent = 'Adding to bag...';
              }

              if (cartDrawerLiveRegion instanceof HTMLElement && !loading) {
                cartDrawerLiveRegion.textContent = '';
              }
            };

            setDrawerLoading(true);
            document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) {
                throw new Error(cart?.description || cart?.message || 'Add to cart failed');
              }

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'wew-spotlight',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );
            } catch (error) {
              console.error(error);
            } finally {
              window.requestAnimationFrame(() => setDrawerLoading(false));
              button.disabled = false;
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.spotlightTarget) {
          activate(activeTab.dataset.spotlightTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiSpotlight());
    document.addEventListener('shopify:section:load', (event) => initChibiSpotlight(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-story-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiStories = (scope = document) => {
      scope.querySelectorAll('[data-wew-story-collections]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-story-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-story-panel]'));
        const seeAll = section.querySelector('[data-story-see-all]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.storyTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);

            if (isActive && seeAll && panel.dataset.storyUrl) {
              seeAll.href = panel.dataset.storyUrl;
            }
          });
        };

        tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.storyTarget)));

        section.querySelectorAll('[data-wew-story-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) throw new Error(cart?.description || cart?.message || 'Add to cart failed');

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'wew-story-collections',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.storyTarget) {
          activate(activeTab.dataset.storyTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiStories());
    document.addEventListener('shopify:section:load', (event) => initChibiStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-bestsellers"] && !Shopify.designMode) return;
  try {
    
  class MyPerfumeRail {
    constructor(section) {
      if (!section || section.dataset.ready === 'true') return;
      this.section = section;
      this.root = section.querySelector('[data-myperfume-carousel]');
      this.track = section.querySelector('[data-myperfume-track]');
      this.prev = section.querySelector('[data-myperfume-prev]');
      this.next = section.querySelector('[data-myperfume-next]');
      if (!this.track) return;
      if (!this.root) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
      this.root.style.scrollBehavior = 'smooth';

      let startX = 0;
      let startY = 0;
      let startScroll = 0;
      let dragging = false;
      let pointerMoved = false;
      let gestureLocked = false;
      let gestureAxis = null;

      this.root.addEventListener('pointerdown', (event) => {
        dragging = true;
        pointerMoved = false;
        gestureLocked = false;
        gestureAxis = null;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = this.root.scrollLeft;
      });

      this.root.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!gestureLocked) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

          gestureLocked = true;
          gestureAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';

          if (gestureAxis === 'x') {
            pointerMoved = true;
            this.root.setPointerCapture(event.pointerId);
            this.root.style.scrollSnapType = 'none';
          } else {
            dragging = false;
            this.root.style.scrollSnapType = 'x mandatory';
            return;
          }
        }

        if (gestureAxis !== 'x') return;

        event.preventDefault();
        this.root.scrollLeft = startScroll - deltaX;
      });

      const stopDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        this.root.style.scrollSnapType = 'x mandatory';
        if (event && this.root.hasPointerCapture(event.pointerId)) {
          this.root.releasePointerCapture(event.pointerId);
        }
        if (pointerMoved && gestureAxis === 'x') {
          this.snapToNearest();
        }
      };

      this.root.addEventListener('pointerup', stopDrag);
      this.root.addEventListener('pointercancel', stopDrag);
      this.root.addEventListener('pointerleave', stopDrag);

      section.dataset.ready = 'true';
    }

    scroll(direction) {
      const card = this.track.firstElementChild;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const amount = (card?.clientWidth || this.root.clientWidth * 0.8) + gap;
      this.root.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    snapToNearest() {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const step = card.clientWidth + gap;
      if (!step) return;
      const nextIndex = Math.round(this.root.scrollLeft / step);
      this.root.scrollTo({ left: nextIndex * step, behavior: 'smooth' });
    }
  }

  const initMyPerfumeRails = (scope = document) => {
    scope.querySelectorAll('[data-myperfume-rail-section]').forEach((node) => new MyPerfumeRail(node));
  };

  const initMyPerfumeBuyNowCards = (scope = document) => {
    scope.querySelectorAll('[data-buy-now-card-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const variantInput = form.querySelector('[data-variant-id-input]');
      const buttons = Array.from(form.closest('.myperfume-bestsellers__card')?.querySelectorAll('[data-size-button]') || []);
      if (!variantInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          variantInput.value = button.dataset.variantId || variantInput.value;
          buttons.forEach((other) => {
            const isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMyPerfumeRails());
  document.addEventListener('DOMContentLoaded', () => initMyPerfumeBuyNowCards());
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeRails(event.target));
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeBuyNowCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-dark-collection"] && !Shopify.designMode) return;
  try {
    
  const initMyPerfumeDarkBuyNowCards = (scope = document) => {
    scope.querySelectorAll('[data-buy-now-card-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      const variantInput = form.querySelector('[data-variant-id-input]');
      const buttons = Array.from(form.closest('.myperfume-dark-card')?.querySelectorAll('[data-size-button]') || []);
      if (!variantInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          variantInput.value = button.dataset.variantId || variantInput.value;
          buttons.forEach((other) => {
            const isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMyPerfumeDarkBuyNowCards());
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeDarkBuyNowCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-footer-promo"] && !Shopify.designMode) return;
  try {
    
  const initStoreFooterFeatureCarousel = (scope = document) => {
    scope.querySelectorAll('.store-footer').forEach((section) => {
      if (section.dataset.featureCarouselReady === 'true') return;
      section.dataset.featureCarouselReady = 'true';

      const track = section.querySelector('.store-footer__features');
      if (!track || track.children.length < 2) return;

      let timer = null;

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        timer = window.setInterval(() => {
          const slides = Array.from(track.children);
          const first = slides[0];
          if (!first) return;

          const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
          const step = first.getBoundingClientRect().width + gap;
          const maxScroll = track.scrollWidth - track.clientWidth - 1;

          if (track.scrollLeft >= maxScroll) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: step, behavior: 'smooth' });
          }
        }, 2800);
      };

      start();
      window.addEventListener('resize', start, { passive: true });
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });
      track.addEventListener('touchcancel', start, { passive: true });
    });
  };

  const initStoreFooterAccordions = (scope = document) => {
    scope.querySelectorAll('.store-footer__menu').forEach((details) => {
      if (details.dataset.ready === 'true') return;
      details.dataset.ready = 'true';

      const syncState = () => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          details.open = false;
        } else {
          details.open = true;
        }
      };

      syncState();
      window.addEventListener('resize', syncState, { passive: true });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initStoreFooterFeatureCarousel());
  document.addEventListener('DOMContentLoaded', () => initStoreFooterAccordions());
  document.addEventListener('shopify:section:load', (event) => initStoreFooterFeatureCarousel(event.target));
  document.addEventListener('shopify:section:load', (event) => initStoreFooterAccordions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rauhath-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateCartCount = (itemCount) => {
      const cartLink = document.querySelector('.rauhath-header__actions a[href*="/cart"]');
      if (!cartLink) return;

      let countNode = cartLink.querySelector('.rauhath-header__cart-count');
      if (!countNode) {
        countNode = document.createElement('span');
        countNode.className = 'rauhath-header__cart-count';
        cartLink.appendChild(countNode);
      }

      if (itemCount > 0) {
        countNode.textContent = String(itemCount);
        countNode.hidden = false;
        countNode.removeAttribute('aria-hidden');
      } else {
        countNode.textContent = '0';
        countNode.hidden = true;
        countNode.setAttribute('aria-hidden', 'true');
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
